import { render } from "./Movil.vue?vue&type=template&id=dab3b0f4&scoped=true"
import script from "./Movil.vue?vue&type=script&lang=js"
export * from "./Movil.vue?vue&type=script&lang=js"

import "./Movil.vue?vue&type=style&index=0&id=dab3b0f4&scoped=true&lang=scss"

import exportComponent from "/builds/aplicaciones_mides/pat_qr/QRreader/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dab3b0f4"]])

export default __exports__